import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ContentfulMetafieldCollection } from '@jbhi-fi/apis/src/contentful/types';
import docReady from '../receipts/docReady';
import { SellerCollection } from '@jbhi-fi/components/src/views/SellerCollection/SellerCollection';
import { MarketplaceSeller } from '@jbhi-fi/components/src/Marketplace/factories/marketplaceSellerFactory';
import { toCamelCase } from '@jbhi-fi/utils/src/toCamelCase';
import { SellerCollectionProductsContainer } from './components/collections/SellerCollectionProductsContainer';
import { hideZendeskDepartment } from '@jbhi-fi/utils/src/zendesk/zendesk';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

const SELLER_COLLECTION_ROOT_ID = 'collection-container';

docReady(async () => {
  const collectionRoot = document.getElementById(SELLER_COLLECTION_ROOT_ID);
  const collection: ContentfulMetafieldCollection | undefined = window.Jbhifi.collection;
  const marketplaceSeller: MarketplaceSeller | undefined = window.Jbhifi.marketplaceSeller
    ? toCamelCase(window.Jbhifi.marketplaceSeller)
    : undefined;

  if (!collection || !collectionRoot || !marketplaceSeller) {
    return drawDefaultLayout();
  }

  const root = createRoot(collectionRoot);
  root.render(
    <BaseContentProvider shopifyProductActionsProviderProps={{ attachPageType: 'collections' }}>
      <DefaultLayout>
        <SellerCollection
          seller={marketplaceSeller}
          disclaimers={window.Jbhifi.disclaimers}
          productsTabContents={<SellerCollectionProductsContainer collection={collection} seller={marketplaceSeller} />}
        />
      </DefaultLayout>
    </BaseContentProvider>
  );

  await hideZendeskDepartment(window.Jbhifi?.zendeskDepartmentIds?.askForADeal);
});
